import { configureStore } from '@reduxjs/toolkit';
import uiReducer from './slices/uiSlice';
import productsReducer from './slices/productsSlice';
import categoriesReducer from './slices/categoriesSlice';
import inventoryReducer from './slices/inventorySlice';
import ordersReducer from './slices/ordersSlice';
import customersReducer from './slices/customersSlice';

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    products: productsReducer,
    categories: categoriesReducer,
    inventory: inventoryReducer,
    orders: ordersReducer,
    customers: customersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

// TypeScript types removed for JavaScript compatibility
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;